import numeral from 'numeral';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const hasMoreData = (data, size, totalResults?) => {
  if (totalResults) {
    /* pageSize must be reduced by 1 because lastPageSize is also being calculated,
       error mainly shows up by failing to provide true if last page is in question.
       For example, totalResults is 47, 1st page is fetched with 25 records. By old logic
       it would return false, because 47 < 1 * 25 + 25, even tho we still have 22 records up.
    */
    const pageSize = data.pages.length - 1;
    const lastPageSize = data.pages[data.pages.length - 1].results.length;

    return totalResults > pageSize * size + lastPageSize;
  }
  return data && data.pages[0]?.length === size && data.pages[data.pages.length - 1].length > 0;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const formatResultsText = (data) => {
  const totalResults = data?.pages[0]?.totalResults;
  if (!totalResults) {
    return 'No Results Found';
  }
  if (totalResults === 1) {
    return '1 result';
  }
  return `${numeral(totalResults).format('0,0')} results`;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getCountOfRemainingRecords = (data, size) => {
  const totalResults = data?.pages[0]?.totalResults;
  const numberOfPages = data?.pages?.length;
  const lastPageSize = data.pages[data.pages.length - 1].results.length;

  return totalResults - ((numberOfPages - 1) * size + lastPageSize);
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getLoadMoreButtonText = (data, size) => {
  const remainingRecords = getCountOfRemainingRecords(data, size);

  return remainingRecords > size ? size : remainingRecords;
};
